import KingBedIcon from '@material-ui/icons/KingBed';
import BathtubIcon from '@material-ui/icons/Bathtub';
import DirectionsCarIcon from '@material-ui/icons/DirectionsCar';
import TvIcon from '@material-ui/icons/Tv';
import KitchenIcon from '@material-ui/icons/Kitchen';
import RoomServiceIcon from '@material-ui/icons/RoomService';
import LocalLaundryServiceIcon from '@material-ui/icons/LocalLaundryService';
import DeckIcon from '@material-ui/icons/Deck';
import CropFreeIcon from '@material-ui/icons/CropFree';
import CropDinIcon from '@material-ui/icons/CropDin';

const prototypes = [
    {
        id: "bellota",
        name: "Bellota",
        description: "",
        image: "/img/prototipos/Bellota3.jpg",
        image2: "img/prototipos/Prototipo5_AF.jpg",
        model: "",
        features: [
            { icon: KingBedIcon, text: "Recamaras: 3" },
            { icon: BathtubIcon, text: "Baños: 2.5" },
            { icon: DirectionsCarIcon, text: "Cochera para 2 autos" },
            { icon: TvIcon, text: "Sala" },
            { icon: KitchenIcon, text: "Cocina" },
            { icon: RoomServiceIcon, text: "Comedor" },
            { icon: LocalLaundryServiceIcon, text: "Área de lavado" },
            { icon: CropFreeIcon, text: "5.538 m frente" },
            { icon: CropDinIcon, text: "113.789 m2 de construcción" }
        ],
    },
    {
        id: "chapulin",
        name: "Chapulín",
        description: "",
        image: "/img/prototipos/Chapulin3.jpg",
        image2: "img/prototipos/Prototipo4_AF.jpg",
        model: "",
        features: [
            { icon: KingBedIcon, text: "Recamaras: 3" },
            { icon: BathtubIcon, text: "Baños: 2.5" },
            { icon: DirectionsCarIcon, text: "Cochera para 2 autos" },
            { icon: TvIcon, text: "Sala" },
            { icon: KitchenIcon, text: "Cocina" },
            { icon: RoomServiceIcon, text: "Comedor" },
            { icon: LocalLaundryServiceIcon, text: "Área de lavado" },
            { icon: TvIcon, text: "Sala de TV" },
            { icon: CropFreeIcon, text: "7.302 m frente" },
            { icon: CropDinIcon, text: "93.574 m2 de construcción" }
        ],
    },
    {
        id: "colibri",
        name: "Colibrí",
        description: "",
        image: "/img/prototipos/Colibri3.jpg",
        image2: "img/prototipos/Prototipo1_AF.jpg",
        model: "",
        features: [
            { icon: KingBedIcon, text: "Recamaras: 3" },
            { icon: BathtubIcon, text: "Baños: 2.5" },
            { icon: DirectionsCarIcon, text: "Cochera para 2 autos" },
            { icon: TvIcon, text: "Sala" },
            { icon: KitchenIcon, text: "Cocina" },
            { icon: RoomServiceIcon, text: "Comedor" },
            { icon: LocalLaundryServiceIcon, text: "Cuarto de servicio" },
            { icon: DeckIcon, text: "Patio" },
            { icon: CropFreeIcon, text: "7.302 m frente" },
            { icon: CropDinIcon, text: "111.026 m2 de construcción" }
        ],
    },
    {
        id: "floresta",
        name: "Floresta",
        description: "Pensado para adultos mayores",
        image: "/img/prototipos/Floresta3.jpg",
        image2: "img/prototipos/Prototipo3_AF.jpg",
        model: "Torre II - Tipo A",
        features: [
            { icon: KingBedIcon, text: "Recamaras: 1" },
            { icon: BathtubIcon, text: "Baños: 1" },
            { icon: DirectionsCarIcon, text: "Cochera para 1 auto" },
            { icon: TvIcon, text: "Sala" },
            { icon: KitchenIcon, text: "Cocina" },
            { icon: RoomServiceIcon, text: "Comedor" },
            { icon: LocalLaundryServiceIcon, text: "Patio con área de lavado" },
            // { icon: DeckIcon, text: "Patio" },
            // { icon: TvIcon, text: "Sala de TV" },
            { icon: CropFreeIcon, text: "5.700m / 5.500m frente" },
            { icon: CropDinIcon, text: "54.827m2 / 54.414m2 de construcción" }
        ],
    },
    {
        id: "encino",
        name: "Encino",
        description: "",
        image: "/img/prototipos/Encino3.jpg",
        image2: "img/prototipos/Prototipo2_AF.jpg",
        model: "Torre II - Tipo A",
        features: [
            { icon: KingBedIcon, text: "Recamaras: 3" },
            { icon: BathtubIcon, text: "Baños: 2.5" },
            { icon: DirectionsCarIcon, text: "Cochera para 2 autos" },
            { icon: TvIcon, text: "Sala" },
            { icon: KitchenIcon, text: "Cocina" },
            { icon: RoomServiceIcon, text: "Comedor" },
            { icon: LocalLaundryServiceIcon, text: "Cuarto de servicio" },
            { icon: DeckIcon, text: "Patio" },
            { icon: TvIcon, text: "Sala de TV" },
            { icon: CropFreeIcon, text: "6.153 / 6.880 / 6.747 m frente" },
            { icon: CropDinIcon, text: "126.946 / 129.412 / 128.820 m2 de construcción" }
        ],
    }
];

export default prototypes;
